<template>
  <div class="notice-field">
    <NoticeBox
      :i18n-key="configs.label"
      :severity="configs.options?.severity || 'info'"
    />
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue';
import { FieldConfig } from '@/types';
import NoticeBox from '@/components/template-builder/panels/NoticeBox.vue';

export default defineComponent({
  name: 'Notice',

  components: {
    NoticeBox,
  },

  props: {
    configs: {
      type: Object as PropType<FieldConfig>,
      required: true,
    },
  },
});
</script>

<style scoped lang="scss">
.notice-field {
  margin-top: 0.75rem;
}
</style>
